export const educationData = [
  {
    id: 1,
    institution: "Maharishi International University, Fairfield, IA",
    course: "Software Development",
    startYear: "",
    endYear: "",
  },
  // {
  //   id: 2,
  //   institution: "Mekelle University, Ethiopia",
  //   course: "BSC in Electrical Mechanical",
  //   startYear: "",
  //   endYear: "",
  // },
  // {
  //   id: 3,
  //   institution: "Microlink Information Technology College, Addis Ababa Ethiopia",
  //   course: "Associate degree computer science",
  //   startYear: "",
  //   endYear: "",
  // },
  // {
  //   id: 3,
  //   institution: "South West Academy School, Addis Ababa Ethiopia",
  //   course: "Higher Secondary Education",
  //   startYear: "",
  //   endYear: "",
  // },
];
